<template>
  <p>{{paragraph}}</p>
</template>

<script setup>
import { fieldFactory } from '@/helper/popFieldFactory';
const props = defineProps({
    popStoreId:String
})

const paragraph = fieldFactory('paragraph', props.popStoreId)
</script>

<style>

</style>